import { render, staticRenderFns } from "./CreateOrderPopup.vue?vue&type=template&id=0241d1ea"
import script from "./CreateOrderPopup.vue?vue&type=script&lang=ts"
export * from "./CreateOrderPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports